import type { IAccountUserLicenses } from './AccountUserLicenses.interface';

export default class AccountUserLicenses implements IAccountUserLicenses {
  in1: string;
  id1: string;
  in2: string;
  id2: string;
  in3: string;
  id3: string;
  in4: string;
  id4: string;
  in5: string;
  id5: string;
  in6: string;
  id6: string;

  static build = (data: IAccountUserLicenses) => new AccountUserLicenses(data);
  static blank = () => new AccountUserLicenses();

  /**
   * Constructor
   * @param {IAccountUserLicenses} data
   */
  constructor(data?: IAccountUserLicenses) {
    this.in1 = data?.in1 || '';
    this.id1 = data?.id1 || '';
    this.in2 = data?.in2 || '';
    this.id2 = data?.id2 || '';
    this.in3 = data?.in3 || '';
    this.id3 = data?.id3 || '';
    this.in4 = data?.in4 || '';
    this.id4 = data?.id4 || '';
    this.in5 = data?.in5 || '';
    this.id5 = data?.id5 || '';
    this.in6 = data?.in6 || '';
    this.id6 = data?.id6 || '';
  }
}
